import KT01BaseLayout from 'general/components/BaseLayout/KT01BaseLayout';
import { Route, Routes } from 'react-router-dom';
import ChargePointAddScreen from '../ChargePoint/screens/ChargePointAddScreen';
import ChargePointDetailScreen from '../ChargePoint/screens/ChargePointDetailScreen';
import ChargeTransactionDetailScreen from '../ChargeTransaction/screens/ChargeTransactionDetailScreen';
import ChargePointListScreen from './screens/ChargePointListScreen';

function ChargePoint(props) {
    return (
        <KT01BaseLayout isFullScreen={true}>
            <div className="container-fluid px-0">
                <Routes>
                    <Route path="" element={<ChargePointListScreen />} />
                    <Route path="add" element={<ChargePointAddScreen />} />
                    <Route path=":chargePointId" element={<ChargePointDetailScreen />} />
                    <Route path=":chargePointId/edit" element={<ChargePointAddScreen />} />
                    <Route
                        path=":chargePointId/transaction/:chargeTransactionId"
                        element={<ChargeTransactionDetailScreen />}
                    />
                    <Route path="*" element={<>Đường dẫn không hợp lệ</>} />
                </Routes>
            </div>
        </KT01BaseLayout>
    );
}

export default ChargePoint;
